// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations (you can structure these differently if preferred)
import en from './locales/en.json';
import fr from './locales/fr.json';

i18n
  .use(LanguageDetector) // Detects user's language preference
  .use(initReactI18next)  // Bind i18n to React
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    supportedLngs: ['en', 'fr'],
    nonExplicitSupportedLngs: true, // map en-CA -> en, fr-CA -> fr, etc.
    detection: {
      // Prefer browser language, then previously saved preference
      order: ['navigator', 'localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      checkWhitelist: true
    },
    fallbackLng: 'en', // Use English if language is not available
    interpolation: { escapeValue: false }, // React already does escaping
  });

// Keep <html lang> in sync with current language
const setHtmlLang = (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lng);
  }
};

setHtmlLang(i18n.language || 'en');
i18n.on('languageChanged', setHtmlLang);

export default i18n;